import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { FormattedMessage } from 'react-intl';
import { BulkUpdateValidationFeedback } from '../../../sharedComponents/bulkStatusUpdate/BulkUpdateValidationFeedback';
import {
    BulkStatusError,
    getDefaultBulkStatusErrorMessageId,
} from '../../../sharedComponents/bulkStatusUpdate/BulkStatusErrorMessage';
import { ServiceOrderBulkUpdatePreviewErrorCode, ServiceOrderBulkUpdatePreviewResult } from '../serviceOrder.types';
import { BulkUpdateMaxSizeErrorMessage } from '../../../sharedComponents/bulkStatusUpdate/BulkUpdateMaxSizeErrorMessage';
import { SERVICE_ORDER_MAX_SELECTION_SIZE } from './ServiceOrderBulkSelectionDropdown';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';

type ServiceOrderBulkUpdateDialogProps = {
    readonly previewResult: ServiceOrderBulkUpdatePreviewResult;
    readonly onClose: () => void;
};

export const ServiceOrderBulkUpdateDialog = ({ previewResult, onClose }: ServiceOrderBulkUpdateDialogProps) => {
    const isSuccess = previewResult.success;
    const validOrdersCount = isSuccess ? previewResult.serviceOrders.length : 0;
    const invalidOrders: BulkStatusError<ServiceOrderBulkUpdatePreviewErrorCode>[] = isSuccess
        ? previewResult.invalidOrders.map((error) => ({
              errorCode: error.errorCode,
              identifiers: error.orderIds,
              identifierType: 'ORDER',
          }))
        : [];
    const nextButtonDisabled = !isSuccess || validOrdersCount === 0;

    const requestError =
        !isSuccess && previewResult.errorCode === 'size-exceeded' ? (
            <BulkUpdateMaxSizeErrorMessage maxBulkSize={SERVICE_ORDER_MAX_SELECTION_SIZE} />
        ) : undefined;

    const handleOnClose = () => {
        onClose();
    };

    return (
        <Dialog show onClose={onClose} bsSize={Dialog.SIZE_LG}>
            <Dialog.Title
                title={<FormattedMessage id="outboundOrderBook.transportAssignments.bulkUpdate.dialogTitle" />}
            />
            <Dialog.Body>
                <BulkUpdateValidationFeedback
                    isSuccess={isSuccess}
                    validItemsCount={validOrdersCount}
                    invalidItems={invalidOrders}
                    getErrorMessageId={getServiceOrderErrorMessageId}
                    requestError={requestError}
                />
            </Dialog.Body>
            <Dialog.Footer>
                <ButtonToolbar>
                    <Button onClick={handleOnClose}>
                        <FormattedMessage id="outboundOrderBook.common.button.cancel" />
                    </Button>
                    <Button bsStyle={Button.PRIMARY} disabled={nextButtonDisabled} onClick={() => {}}>
                        <FormattedMessage id="outboundOrderBook.common.button.next" />
                    </Button>
                </ButtonToolbar>
            </Dialog.Footer>
        </Dialog>
    );
};

const getServiceOrderErrorMessageId = (errorCode: ServiceOrderBulkUpdatePreviewErrorCode) => {
    switch (errorCode) {
        case ServiceOrderBulkUpdatePreviewErrorCode.UNKNOWN_ORDER:
            return 'outboundOrderBook.bulkStatusUpdate.error.unknownAssignement';
        case ServiceOrderBulkUpdatePreviewErrorCode.UNSUPPORTED_ORDER_TYPE:
            return 'outboundOrderBook.bulkStatusUpdate.error.unsupportedAssignmentType';
        default:
            return getDefaultBulkStatusErrorMessageId(errorCode);
    }
};
